import React from "react";
export default function ForbidentView() {
  return <>403</>;
}
